import React from 'react';
import { Row, Col } from 'reactstrap';

const SettingsTab = () => {
  return (
    <Row>
      <Col md={12}>
        <div className="text-center p-4">
          <h5>Settings</h5>
          <p className="text-muted">Account settings content will be implemented here.</p>
        </div>
      </Col>
    </Row>
  );
};

export default SettingsTab; 